<div class="pb-10 overflow-y-auto">
	<app-teranet-pin-view></app-teranet-pin-view>
	<div class="p-10">
		<app-teranet-instruments [showRequisition]="true"></app-teranet-instruments>

		<div class="mt-20">
			<div class="font-bold mb-10">Writs</div>
			<app-writ-results
				*ngIf="hasSavedWrits$ | async; else noSavedWrits"
			></app-writ-results>
		</div>
	</div>
</div>

<ui-content-footer
	[primaryAction]="{ text: 'Complete', action: next }"
	[secondaryAction]="{ text: 'Back', action: back }"
></ui-content-footer>

<ng-template #noSavedWrits>
	<app-no-saved-writs></app-no-saved-writs>
</ng-template>
